import React from 'react';
import { Size } from '../../../../Enums/Size.enum';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import NewInApp, { NewInAppData } from './NewInApp';

interface Props extends BaseModalProps {
	data: NewInAppData;
}

const NewInAppModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.ORSMActivationConfirmation.modalTitle'
			headerEnabled={false}
			size={Size.LG}
			modalStyle={{ background: 'transparent' }}>
			<NewInApp data={props.data} onClose={props.onClose} />
		</BaseModal>
	);
};

export default NewInAppModal;
